import {Component, Input, OnInit} from '@angular/core';
import {ActiveApplicationTile} from '../tiles/tiles';
import {LoanApplicationService} from '../../../../service/loan-application.service';
import {TileFactory} from '../tiles/tile-factory';
import {LoansAndApplicationsSegregator} from '../loans-and-applications-segregator';
import {LoanApplicationTransition} from '../../../../model/LoanApplicationTransition';

@Component({
    selector: 'app-active-application',
    templateUrl: './active-application.component.html',
    styleUrls: ['./active-application.component.scss']
})
export class ActiveApplicationComponent implements OnInit {
    @Input()
    userId: string;

    activeApplicationTiles: ActiveApplicationTile[];

    constructor(private loanApplicationService: LoanApplicationService,
                private segregator: LoansAndApplicationsSegregator, private tileFactory: TileFactory) {
    }

    async ngOnInit(): Promise<void> {
        const loanApplications = await this.loanApplicationService.getLoanApplicationsByUserId(this.userId);
        const loanApplicationIds = loanApplications.map(loanApplication => loanApplication.id);

        const transitions: LoanApplicationTransition[] = await this.loanApplicationService.getAllTransitionsByLoanApplicationIds(loanApplicationIds);
        const yetToBeSubmittedLoanApplications = this.segregator.filterYetToBeSubmittedLoanApplications(loanApplications, transitions);
        this.activeApplicationTiles = yetToBeSubmittedLoanApplications ? yetToBeSubmittedLoanApplications.map(loanApplication =>
            this.tileFactory.createForActiveApplication(loanApplication)) : null;
    }
}
